import api from "../../config/axios";
 
const syncPortfolioData = async (userId: string, phoneNumber: string) => {
  try {
    const backendUrl = `${process.env.REACT_APP_API_URL}/customer/casdata/fetch-and-save`;
    const response = await api.post(backendUrl, { userId, phoneNumber });
    return response.data;
  } catch (err) {
    console.error('Failed to sync portfolio data:', err);
    throw err;
  }
};

export default {syncPortfolioData}